var _g, _ellipse, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7540_126644)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.5,
    cy: 59.2163,
    rx: 54.5455,
    ry: 54.8295,
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.6637,
    cy: 59.3801,
    rx: 47.7273,
    ry: 47.9758,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 58.2135C56.3438 58.2135 52.125 56.497 48.8438 53.0641C45.5625 49.6313 43.9219 45.2176 43.9219 39.823C43.9219 34.4285 45.5625 30.0148 48.8438 26.5819C52.125 23.1491 56.3438 21.4326 61.5 21.4326C66.6562 21.4326 70.875 23.1491 74.1562 26.5819C77.4375 30.0148 79.0781 34.4285 79.0781 39.823C79.0781 45.2176 77.4375 49.6313 74.1562 53.0641C70.875 56.497 66.6562 58.2135 61.5 58.2135ZM24 97.569V86.0443C24 82.9384 24.7422 80.282 26.2266 78.0751C27.7109 75.8683 29.625 74.1927 31.9687 73.0484C37.2031 70.5964 42.2227 68.7573 47.0273 67.5313C51.832 66.3053 56.6562 65.6922 61.5 65.6922C66.3438 65.6922 71.1484 66.3257 75.9141 67.5926C80.6797 68.8595 85.6797 70.6781 90.9141 73.0484C93.3359 74.1927 95.2891 75.8683 96.7734 78.0751C98.2578 80.282 99 82.9384 99 86.0443V97.569H24Z",
    fill: "#5A5656",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7540_126644",
    x: 0.954529,
    y: 0.386719,
    width: 121.091,
    height: 121.659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7540_126644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7540_126644",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/defaultUser.1d7d7067bf803f6d07cf80e9b8094011.svg";
export { ForwardRef as ReactComponent };